module.exports = __webpack_public_path__ + "img/00034.5bb99fe1.webp";